const TYPE = 'USER_UPDATE';

const action = (payload) => (dispatch) => dispatch({ type: TYPE, payload });

export { action, TYPE };
